var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meter"},[_c('div',{class:[_vm.meterLevel[_vm.nowLevel], 'box']},[_vm._l((_vm.meterText),function(item,index){return _c('div',{key:item,class:['progress', _vm.nowLevel > index - 1 ? 'active' : '']})}),_c('p',[_vm._v(_vm._s(_vm.meterText[_vm.nowLevel]))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }